import { Card } from "antd";
import React from "react";
import ReactApexChart from "react-apexcharts";

const RevenueGraph = ({ balanceData }) => {
  const series = [
    {
      data: balanceData.monthlyRevenues.map((month) => parseInt(month.revenue)),
    },
  ];

  const options = {
    chart: {
      fontFamily: "Satoshi, sans-serif",
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
      animations: {
        enabled: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        endingShape: "rounded",
        borderRadius: 2,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 4,
      colors: ["transparent"],
    },
    xaxis: {
      categories: balanceData.monthlyRevenues.map((month) => month.period),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "left",
      fontFamily: "inter",

      markers: {
        radius: 99,
      },
    },
    yaxis: {
      title: false,
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    fill: {
      opacity: 1,
    },

    tooltip: {
      marker: {
        show: false,
      },
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: function () {
            return undefined;
          },
        },
      },
    },
  };

  return (
    <Card title={<h5> Monthly Revenue</h5>} className="mb-8 w-full rounded-lg p-6">
      <div className="relative">
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={350}
        />
      </div>
    </Card>
  );
};

export default RevenueGraph;